import axios from "axios";
import { stringify } from "qs";

// 巨丰圈子「生成小程序 scheme」接口，与 H5 主站(aigupiao.com)不同源，独立直连
// const SCHEME_BASE = "https://api.zx017.net";
const SCHEME_BASE = "https://api.jufengquan.com";

export default {
  /**
   * 生成小程序 URL Scheme 短链
   * 参考 PC 后台实现：zft_pc-zongfu-vue/src/views/settings/components/info.vue 的 copyMiniLink
   * POST https://api.jufengquan.com/v1/wechat/mini/generateScheme
   *
   * @param {Object} data
   *   - path:        小程序页面路径，如 "pages/views/circle/index"
   *   - query:       小程序页面入参 query 串，如 "id=xx&from=app&user_id=xx&token=xx"
   *   - env_version: "trial"(体验版) / "release"(正式版)
   *   - is_expire:   0(长期有效)
   * @returns {Promise<Object>} 后端 body：{ code, status, message, data: { openlink/scheme/url } }
   */
  async generateScheme(data) {
    const res = await axios({
      method: "post",
      url: SCHEME_BASE + "/v1/wechat/mini/generateScheme",
      data: stringify(data),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    return res.data;
  },
};
